import React, { Component } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import EmployerCarousel from '../Home/EmployerCarousel';
import Faq from '../Faq/Faq';
import AnimatedCounter from '../Common/AnimatedCounter';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class TrainingIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trainings: [],
            trainers: [],
            testimonials: [],
            loadingTrainings: true,
            loadingTrainers: false,
            loadingTestimonials: false,
            error: null,
        };
        this._isMounted = false;
        this.trainingsController = null;
        this.trainersController = null;
        this.testimonialsController = null;
        this.testimonialSliderRef = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchTrainings();
        this.fetchTrainers();
        this.fetchTestimonials();
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.trainingsController) this.trainingsController.abort();
        if (this.trainersController) this.trainersController.abort();
        if (this.testimonialsController) this.testimonialsController.abort();
    }

    fetchTrainings = () => {
        const token = localStorage.getItem('backend-jwt-token');
        this.trainingsController = new AbortController();

        axios.get('/api/trainings/frontend-list', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainingsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.data) {
                this.setState({
                    trainings: response.data.data,
                    loadingTrainings: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainings:', error);
                this.setState({
                    error: 'Failed to load trainings',
                    loadingTrainings: false
                });
            }
        });
    }

    fetchTrainers = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTrainers: true });

        this.trainersController = new AbortController();

        axios.get('/api/trainings/trainers/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainersController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    trainers: response.data.data,
                    loadingTrainers: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainers:', error);
                this.setState({
                    loadingTrainers: false
                });
            }
        });
    }

    fetchTestimonials = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTestimonials: true });

        this.testimonialsController = new AbortController();

        axios.get('/api/trainings/testimonials/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.testimonialsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    testimonials: response.data.data,
                    loadingTestimonials: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching testimonials:', error);
                this.setState({
                    loadingTestimonials: false
                });
            }
        });
    }



    handleViewTraining = (slug) => {
        // Navigate to training detail page using slug
        window.location.href = `/training/${slug}`;
    }

    handleEnrollTraining = (trainingId) => {
        alert('Enrollment functionality coming soon!');
    }

    handleTestimonialPrevClick = () => {
        if (this.testimonialSliderRef.current) {
            this.testimonialSliderRef.current.slickPrev();
        }
    }

    handleTestimonialNextClick = () => {
        if (this.testimonialSliderRef.current) {
            this.testimonialSliderRef.current.slickNext();
        }
    }

    renderStars = (rating) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <i key={i} className={`fas fa-star ${i < rating ? '' : 'text-muted'}`}></i>
            );
        }
        return stars;
    }

    render() {
        const { trainings, trainers, testimonials, loadingTrainings } = this.state;

        if (loadingTrainings) {
            return (
                <div className="loading-spinner">
                    <p>Loading About...</p>
                </div>
            );
        }

        const slickSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            adaptiveHeight: false,
            lazyLoad: false,
            touchMove: true,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        };

        return (
            <div className="training-homepage about_us">

                <div className="container">
                    <div className="hero-section bg-gray">
                        <div className="hero-wrapper">
                            <div className="hero-content">
                                <h1>
                                    About Solid Future
                                </h1>
                                <h2>
                                   Connect Talent with Opportunity <br/> since 2016
                                </h2>
                                <p>
                                   Solid Future HR Consulting Private Limited is the 
                                   fastest growing one-stop HR solution company. 
                                   Within a short span of time, Solid Future has been 
                                   able to create a niche for itself in the HR solution 
                                   industry through continuous quality service standards and 
                                   the commitment rendered.
                                </p>
                                <p>
                                    A team of corporate professionals with vast experience of 
                                    decades from diversified sectors consists of the SOLID FUTURE 
                                    team. The highest level of certifications for respective training
                                     has been our trainer’s forte. Experience with a blend of 
                                     operations in HR Solutions to training is another strength of 
                                     the team. Consultancy to corporate and turnkey projects for the
                                      total solution is our modus.
                                </p>
                                <div className="hero-buttons">
                                    <button className="text-white py-2 flex-1 bg-secondary rounded">
                                      Explore Our Services
                                    </button>
                                    <button className="text-white py-2 flex-1 bg-primary rounded">
                                      Contact Us
                                    </button>
                                </div>
                            </div>
                            <div className="hero-image">
                                <img src="/uploads/group_image.png" alt="About Image" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="hero-section bg-gray">
                        <div className="hero-wrapper">
                            <div className="hero-image">
                                <img src="/uploads/who_are_we.png" alt="Who Are We Image" />
                            </div>
                            <div className="hero-content">
                                <h1>
                                    Who Are We?
                                </h1>
                                <p>
                                   Solid Future HR Consulting is a trusted one-stop HR solution provider 
                                   offering comprehensive services to meet diverse organizational human resource needs.
                                </p>
                                <p>
                                    We specialize in executive search, permanent recruitment, and manpower outsourcing, 
                                    helping organizations identify, assess, and retain the right talent. Our expertise 
                                    also extends to strategic HR functions, including headhunting, executive assessment, 
                                    organizational culture assessment, and employee value estimation. Through structured 
                                    HR methodologies such as business process improvement, GAP analysis, and employee 
                                    development strategies, we support organizations in building high-performing teams and 
                                    sustainable work cultures.
                                </p>
                                <p>
                                  At Solid Future HR Consulting, we focus on delivering practical, data-driven, and 
                                  customized HR solutions that align people strategies with business objectives.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="hero-section bg-gray">
                        <div className="hero-wrapper">
                            <div className="hero-content">
                                <h1>
                                    Why Solid Future Consulting ?
                                </h1>
                
                                <ul>
                                  <li>Solid Future is a One-Stop-Shop for Clients' every HR requirement.</li>
                                  <li>Expert and Professional Management Crew.</li>
                                  <li>Economical Service with complete satisfaction.</li>
                                  <li>Free replacement would be made with new workers if any worker is found unqualified.</li>
                                  <li>Create a win-win relationship with clients.</li>
                                  <li>A huge database owner of candidate of various levels in recruitment division and able to meet requirement of various types.</li>
                              </ul>

                            </div>
                            <div className="hero-image">
                                <img src="/uploads/solid_group_image.png" alt="Group Image" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Unlock Opportunities Section */}
                <section className="milestone">
                    <div className="container">
                        <div className="milestone-content">
                            <h2>Our Milestones</h2>
                            <h4>Our journey of milestones that defined our growth and success.</h4>
                            <figure>
                                 <img src="/uploads/milestone.png" alt="Milestone Image" />
                            </figure>
                        </div>
                    </div>
                </section>

                {/* Training Cards List */}
                <section className="trainings-section">
                    <div className="container">
                      <div className="bg-gray border-radius-0 mb-0">
                            <div className="abt_short_info">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <h2>
                                      <span>Our Mission</span>
                                    </h2>
                                    <p>
                                      Solid Future HR consulting works with a unique mission of becoming preferred and effective 
                                      services provider to clients and sustain them with assured satisfaction.
                                    </p>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <figure>
                                      <img src="/uploads/ladder.png" alt="Ledder Image" />
                                    </figure>
                                </div>
                              </div>
                            </div>
                            <div className="abt_short_info">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <figure>
                                      <img src="/uploads/vission.png" alt="Vission Image" />
                                    </figure>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <h2>
                                      <span>Our Vision</span>
                                    </h2>
                                    <p>
                                      To be the leading HR consulting company that best understands 
                                      and satisfies the needs of clients by providing overall human 
                                      resources solution.
                                    </p>
                                </div>
                              </div>
                            </div>
                            <div className="abt_short_info">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <h2>
                                      <span>Our Objective</span>
                                    </h2>
                                    <p>
                                      We keep quality in our mind always and hence we provide 
                                      long term quality professional through our dedicated consulting
                                       for specialized areas and be one of the premier HR service
                                        provider.
                                    </p>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <figure>
                                      <img src="/uploads/objective_image.png" alt="Ledder Image" />
                                    </figure>
                                </div>
                              </div>
                            </div>
                            <div className="abt_short_info">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <figure>
                                      <img src="/uploads/vission.png" alt="Vission Image" />
                                    </figure>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <h2>
                                      <span>Our Value</span>
                                    </h2>
                                    <p>
                                      We recognize that every client is important, and hence deserve the very best 
                                      service possible. We will be professional in our approach like understanding, 
                                      competency, ethical, commitment and social responsibility.
                                    </p>
                                </div>
                              </div>
                            </div>
                            <div className="abt_short_info">
                              <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <h2>
                                      <span>Our Methodology</span>
                                    </h2>
                                    <p>
                                      Solid Future HR consulting works with a unique mission of becoming preferred and effective 
                                      services provider to clients and sustain them with assured satisfaction.
                                    </p>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <figure>
                                      <img src="/uploads/objective_image.png" alt="Ledder Image" />
                                    </figure>
                                </div>
                              </div>
                            </div>
                      </div>
                    </div>
                </section>

                {/* Actively Recruiting Employers Section */}
                <EmployerCarousel />

                {/* Statistics Section */}
                <section class="stats-banner">
                    <div class="stat-item">
                        <div class="icon-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
                            </svg>
                        </div>
                        <div class="stat-text">
                            <span class="stat-number">
                                <AnimatedCounter end={20} suffix="K +" />
                            </span>
                            <span class="stat-label">Successfully Hired</span>
                        </div>
                    </div>

                    <div class="stat-item">
                        <div class="icon-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
                            </svg>
                        </div>
                        <div class="stat-text">
                            <span class="stat-number">
                                <AnimatedCounter end={500} suffix=" +" />
                            </span>
                            <span class="stat-label">Partner Employers</span>
                        </div>
                    </div>

                    <div class="stat-item">
                        <div class="icon-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
                            </svg>
                        </div>
                        <div class="stat-text">
                            <span class="stat-number">
                                <AnimatedCounter end={10} suffix=" +" />
                            </span>
                            <span class="stat-label">Years of Excellence</span>
                        </div>
                    </div>
                </section>

                {/* Learn From Our Trainers Section */}
                {trainers.length > 0 && (
                    <section className="trainers-section">
                        <div className="container">
                          <div className="bg-gray border-radius-0 mb-0">
                            <h2 className="section-title">Our Executive Team</h2>
                            <div className="trainers-grid">
                                {trainers.map((trainer, index) => (
                                    <div key={index} className="trainer-card">
                                        <div className="trainer-photo-wrap">
                                            {trainer.photo ? (
                                                <img
                                                    src={`/uploads/emp_img/${trainer.photo}`}
                                                    alt={trainer.name}
                                                    className="trainer-photo"
                                                />
                                            ) : (
                                                <div className="trainer-photo trainer-photo-placeholder">
                                                    <i className="fas fa-user"></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className="trainer-info">
                                            <div className="trainer-name">{trainer.name}</div>
                                            <div className="trainer-designation">{trainer.designation}</div>
                                            <div className="trainer-bio">{trainer.bio || '0+ years of Experience'}</div>
                                            <div className="trainer-social">
                                                {trainer.facebook_url && (
                                                    <a href={trainer.facebook_url} target="_blank" rel="noopener noreferrer" title="Facebook">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                )}
                                                {trainer.twitter_url && (
                                                    <a href={trainer.twitter_url} target="_blank" rel="noopener noreferrer" title="Twitter">
                                                        <i className="fab fa-twitter"></i>
                                                    </a>
                                                )}
                                                {trainer.linkedin_url && (
                                                    <a href={trainer.linkedin_url} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                )}
                                                {trainer.instagram_url && (
                                                    <a href={trainer.instagram_url} target="_blank" rel="noopener noreferrer" title="Instagram">
                                                        <i className="fab fa-instagram"></i>
                                                    </a>
                                                )}
                                                {trainer.whatsapp_number && (
                                                    <a href={`https://wa.me/${trainer.whatsapp_number}`} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                                        <i className="fab fa-whatsapp"></i>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                          </div>
                        </div>
                    </section>
                )}  
                
                <Faq />
                <p className="mt-5 text-center text-muted mb-5 h6">Still have questions? 
                    <Link className="contact_us_purple" to="/contact"> Contact our support team.</Link>
                </p>        
            </div>
        );
    }
}

export default TrainingIndex;